<section class="ticket-toggle-bar flex-wrap" id="ticketToggleBar" [class.contentV2]="viewConfigurations.useMobileViewWithTopMenu">
  <!-- <app-streaming-wrap *ngIf="windowWidth < 1600"></app-streaming-wrap> -->
  <div class="ticket-bar-content" (click)="toggleTicket()">
    <div class="flex50">
      <div class="flex-wrap">
        <div class="flex41">
          <span i18n="Total events@@TicketCombiAndSingleTotalEvents">Mečeva</span>
        </div>
        <div class="flex58">
          <span class="bold">{{orderingForTicketItemGroups.length}}</span>
        </div>
      </div>
      <div class="flex-wrap">
        <div class="flex41">
          <span i18n="Ticket Pay in text@@TicketPayIn">Uplata</span>
        </div>
        <div class="flex58">
          <span class="bold">{{totalStake | number:'1.2-2'}} {{constantValues.CURRENCY}}</span>
        </div>
      </div>
    </div>
    <div class="flex50">
      <div class="flex-wrap">
        <div class="flex41">
          <span i18n="Score first Capitalized@@Odd">Kvota</span>
        </div>
        <div class="flex58">
      <span class="bold">{{totalOdd | number:'1.2-2'}}</span>
        </div>
      </div>
      <div class="flex-wrap">
        <div class="flex41">
          <span i18n="Ticket Pay out text@@TicketPayOut">Isplata</span>
        </div>
        <div class="flex58">
          <span class="bold" *ngIf="!viewConfigurations.ticketShowPotentalWinWitoutTax">{{possibleWin | number:'1.2-2'}} {{constantValues.CURRENCY}}</span>
          <span class="bold" *ngIf="viewConfigurations.ticketShowPotentalWinWitoutTax">{{possibleWinWithoutTax | number:'1.2-2'}} {{constantValues.CURRENCY}}</span>
        </div>
      </div>
    </div>
    <div class="btn-wrap d-none">
      <div class="btn outline-primary" i18n="Show Ticket button@@ShowTicket">Prikaži tiket</div>
    </div>
  </div>
</section>
<div>
  <section class="ticket-main-wrap" id="ticketMainWrap" [class.open]="showTicket" [class.versionV2]="viewConfigurations.useMobileViewWithTopMenu">
    <div class="overlay"></div>
    <div class="close" (click)="toggleTicket()">
      <i class="icon icon-cross"></i>
    </div>
    <div class="flex-column">
      <section class="ticket-wrap box">
        <div class="tab-wrap">
          <div class="tab-item" [class.active]="selectedTab == TicketTabENUM.Ticket" (click)="onTiketChange(TicketTabENUM.Ticket)" i18n="ticket TicketTab title @@ticketTab">Tiket</div>
          <!-- <div class="tab-item" [class.active]="selectedTab == TicketTabENUM.MyTickets" (click)="onTiketChange(TicketTabENUM.MyTickets)" i18n="ticket myTicketsTab  title@@myTicketsTab" *ngIf="!loggedAffiliate || loggedAffiliate.affiliateRole == affiliateRoleEnum.cashier" >Moji Tiketi</div> -->
          <div *ngIf="isMobileView && isUserLoggedIn" class="tab-item" [class.active]="selectedTab == TicketTabENUM.FindTicket" (click)="onTiketChange(TicketTabENUM.FindTicket)" i18n="Ticket check title@@TicketCheckTitle">Provera Tiketa</div>
        </div>

        <div class="tiket-option" *ngIf="selectedTab == TicketTabENUM.Ticket && !viewConfigurations.showOnlySystemTicket">
          <div class="option" [class.active]="selectedBetTypeIndex == COMBI" (click)="onTabChange({index: 0})" i18n="ticket Combi tab title@@ticketTabCombi">OBIČAN</div>
          <div class="option" [class.active]="selectedBetTypeIndex == SYSTEM" (click)="onTabChange({index: 1})" i18n="ticket System tab title@@ticketTabSystem">SISTEM</div>
          <div class="option" [class.active]="selectedBetTypeIndex == SINGLE" (click)="onTabChange({index: 2})" i18n="ticket Single tab title@@ticketTabSingle">SINGLE</div>
        </div>

        <ng-container *ngIf="selectedTab == TicketTabENUM.Ticket">
          <div class="ticket-body-wrap">
            <section class="ticket-body">
              <article class="ticket-item" *ngFor="let orderingGroup of orderingForTicketItemGroups; let i = index">
                <ng-container *ngIf="ticketItemGroups[orderingGroup.eventId]; let ticketItemGroup">
                  <!-- <div class="remove-ticket-event" (click)="removeTicketItemGroup(ticketItemGroup)">x</div> -->
                  <div class="event-info">
                    <div class="date-time">
                      <span class="order-number">{{i+1}}.</span>
                      <span class="code">{{ticketItemGroup.eventCode}}</span>
                      <span class="date">{{ticketItemGroup.eventDate}} {{ticketItemGroup.eventTime}}</span>
                      <!-- <span class="time">{{ticketItemGroup.eventTime}}</span> -->
                      <span class="live-event" *ngIf="ticketItemGroup.isLive">Live</span>
                    </div>
                    <div class="team-name h5">
                      <i class="icon-ex-sm s-icon-{{getSportName(ticketItemGroup.sportId)}} sportid-{{ticketItemGroup.sportId}}" *ngIf='viewConfigurations.showSportIconInTicket'></i>
                      <span class="name">{{ticketItemGroup.eventName}}</span>
                      <span class="super-bet" *ngIf="ticketItemGroup.mappingType == eventMappingTypeEnum.SuperBetEvent">{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</span>
                      <span class="super-bet" *ngIf="ticketItemGroup.mappingType == eventMappingTypeEnum.EventOfDay">{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</span>
                    </div>
                  </div>
                  <div class="outcome-main-wrap">
                    <div class="banker-wrap" *ngIf="showBankers && selectedBetTypeIndex == 1 && !viewConfigurations.useMobileViewWithTopMenu">
                      <input type="checkbox" [(ngModel)]="ticketItemGroup.isInBankersGroup"[attr.id]="ticketItemGroup.eventId" (change)="bankerChanged(ticketItemGroup)" />
                      <label class="square" [attr.for]="ticketItemGroup.eventId"></label>
                    </div>
                    <div class="outcome-content-wrap" [class.no-click]="!ticketItemGroup.isEventPlayable"
                      (click)="expandEventOfTIGroup(ticketItemGroup); $event.stopPropagation();">
                      <ng-container *ngFor="let outcomeId of orderingGroup.outcomeIds"
                      >
                        <div class="outcome-wrap" *ngIf="ticketItemGroup.ticketItems[outcomeId]; let ticketItem"
                          [class.height]="ticketItem.oldOdd != ticketItem.odd"
                          [class.lock-dissabled]="!(ticketItem.isBetOutcomePlayable && ticketItem.isBetPlayable && ticketItemGroup.isEventPlayable && ticketItem.odd > 1)"
                          >
                          <div class="banker-wrap inside-outcome" *ngIf="showBankers && selectedBetTypeIndex == 1 && viewConfigurations.useMobileViewWithTopMenu" (click)=" $event.stopPropagation();" >
                            <input type="checkbox" [(ngModel)]="ticketItemGroup.isInBankersGroup"[attr.id]="ticketItemGroup.eventId" (change)="bankerChanged(ticketItemGroup);" />
                            <label [class.active]="ticketItemGroup.isInBankersGroup" [attr.for]="ticketItemGroup.eventId">FIX</label>
                          </div>
                          <div class="outcome-name-wrap">
                            <div class="bet-type-name">{{ticketItem.betTypeName}}</div>
                            <div class="sbv" *ngIf="ticketItem.sbv">
                              <ng-container *ngIf="!ticketItem.useSbvHandicapPipe">{{ticketItem.sbv}}</ng-container>
                              <ng-container *ngIf="ticketItem.useSbvHandicapPipe">{{ticketItem.sbv | handicapSbv}}</ng-container>
                            </div>
                            <div class="outcome-name" [class.a-l]="ticketItem.betOutcomeName?.length > 10">{{ticketItem.betOutcomeName}}</div>
                          </div>
                          <div class="outcome">
                            <ng-container
                              *ngIf="ticketItem.isBetOutcomePlayable && ticketItem.isBetPlayable && ticketItemGroup.isEventPlayable && ticketItem.odd > 1; else lockedWrap">
                              <span class="old-odd" *ngIf="ticketItem.oldOdd != ticketItem.odd"
                                [ngClass]="{'old-higher': ticketItem.oldOdd > ticketItem.odd, 'old-lower': ticketItem.oldOdd < ticketItem.odd}">{{ticketItem.oldOdd | odd}}</span>
                              <span class="odd">{{ticketItem.odd | odd}}</span>
                            </ng-container>
                            <ng-template #lockedWrap>
                              <i class="icon icon-ex-sm icon-lock"></i>
                              <!-- <div class="icon-wrap">
                                  <app-svg-icon iconId="lock"></app-svg-icon>
                              </div> -->
                            </ng-template>

                          </div>
                          <div class="remove-outcome" (click)="removeTicketItem(ticketItemGroup, ticketItem); $event.stopPropagation();">
                            <!-- <i class="icon icon-cross"></i> -->
                            <i class="icon s-icon-sporticon-clear"></i>
                          </div>

                        </div>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>

              </article>

            </section>
          </div>

          <app-ticket-combi *ngIf="selectedBetTypeIndex == 0 && !viewConfigurations.showOnlySystemTicket"
              [ticketItemGroups]="ticketItemGroups"
              [orderingForTicketItemGroups]="orderingForTicketItemGroups"
              [isOddChanged]="isOddChanged"
              [oddsMap]="oddsMap"
              [minOddsMap]="minOddsMap"
              [isTicketOnline]="isTicketOnline"
              [oddsValidationMode]="oddsValidationMode"
              [ticketChanged]="ticketChanged"
              [setSuperBetMessageType]="superBetMsgType">
          </app-ticket-combi>
          <app-ticket-system *ngIf="selectedBetTypeIndex == 1"
              [ticketItemGroups]="ticketItemGroups"
              [orderingForTicketItemGroups]="orderingForTicketItemGroups"
              [bankersChanged]="isBankersChanged"
              [isOddChanged]="isOddChanged"
              [oddsMap]="oddsMap"
              [minOddsMap]="minOddsMap"
              [isTicketOnline]="isTicketOnline"
              [oddsValidationMode]="oddsValidationMode"
              [ticketChanged]="ticketChanged"
              [selectedEventsInCombinations]="selectedEventsInCombinations"
              (resetSelectedEventsInCombinations)="selectedEventsInCombinations = null"
              [setSuperBetMessageType]="superBetMsgType">
          </app-ticket-system>

          <app-ticket-single *ngIf="selectedBetTypeIndex == 2 && !viewConfigurations.showOnlySystemTicket"
              [ticketItemGroups]="ticketItemGroups"
              [orderingForTicketItemGroups]="orderingForTicketItemGroups"
              [isOddChanged]="isOddChanged"
              [oddsMap]="oddsMap"
              [minOddsMap]="minOddsMap"
              [isTicketOnline]="isTicketOnline"
              [oddsValidationMode]="oddsValidationMode"
              [ticketChanged]="ticketChanged"
              [setSuperBetMessageType]="superBetMsgType">
          </app-ticket-single>

          <section class="ticket-bottom">
            <div class="place-bet-wrap">
              <div class="btn primary rounded" (click)="notifyPlaceBetClicked()"
                *ngIf="orderingForTicketItemGroups.length > 0 && isTicketOnline && ((numberOfBets > 0 && payin >= constantValues.MIN_STAKE && wagerPerBet >= constantValues.MIN_STAKE_PER_COMB && numberOfBets <= constantValues.MAX_COMBINATIONS)); else offilneButton">
              <span *ngIf="!viewConfigurations.useMobileViewWithTopMenu" i18n="Proceed to payment ticket calculator button@@ProceedToPayment">Priprema za uplatu</span>
              <span *ngIf="viewConfigurations.useMobileViewWithTopMenu" i18n="Ticket Pay in text CAPS@@TicketPayInCaps"> UPLATI </span>
              </div>
              <ng-template #offilneButton>
                <div *ngIf="orderingForTicketItemGroups.length == 0; else offlineWithItems" class="offline btn primary rounded"><ng-container i18n="Ticket empty instructions text@@ticketTabEmptyMob">Vaš tiket je prazan</ng-container></div>
                <ng-template #offlineWithItems>
                  <div *ngIf="!isTicketOnline; else onlineWithRestictions" class="offline btn primary rounded"><ng-container i18n="Offline Events In Ticket ticket calculator button@@OfflineEventsInTicket">OFFLINE događaji na tiketu</ng-container></div>
                  <ng-template #onlineWithRestictions>
                    <div *ngIf="numberOfBets == 0; else betsNumNotZero" class="offline btn primary rounded"
                      i18n="Select System Type ticket calculator@@SelectSystemTypeButton">ODABERITE TIP SISTEMA</div>
                    <ng-template #betsNumNotZero>
                      <div *ngIf="numberOfBets > constantValues.MAX_COMBINATIONS; else betsNumGood" class="offline btn primary rounded">
                        <ng-container i18n="Max Number of combinations ticket calculator button@@MaxNumOfCombinations">MAX KOMBINACIJA</ng-container>: {{constantValues.MAX_COMBINATIONS}}
                      </div>
                      <ng-template #betsNumGood>
                        <div *ngIf="constantValues.MIN_STAKE > payin; else minStakeGood" class="offline btn primary rounded">
                          <ng-container i18n="Min stake ticket calculator button@@MinStake">MIN UPLATA</ng-container>: {{constantValues.MIN_STAKE}} {{constantValues.CURRENCY}}
                        </div>
                        <ng-template #minStakeGood>
                          <div *ngIf="constantValues.MIN_STAKE_PER_COMB > wagerPerBet" class="offline btn primary rounded">
                            <ng-container i18n="Min stake per bet calculator button@@MinStakePerBet">MIN UPLATA PO BETU</ng-container>: {{constantValues.MIN_STAKE_PER_COMB}} {{constantValues.CURRENCY}}
                          </div>
                        </ng-template>
                      </ng-template>
                    </ng-template>
                  </ng-template>
                </ng-template>
              </ng-template>
            </div>
            <div class="accept-all">
              <span i18n="ODD CHANGES SPAN@@oddChanges">PROMENA KVOTA</span>

              <div class="radio-wrap">
                <div class="custom-radio">
                  <input type="radio" id="acceptAll" name="acceptOdd" [value]="oddsValidationModeEnum.AcceptAllOdds"
                    [(ngModel)]="oddsValidationMode" [attr.checked]="oddsValidationMode === oddsValidationModeEnum.AcceptAllOdds" (click)="changeOddsValidationMode(oddsValidationModeEnum.AcceptAllOdds)">
                  <label for="acceptAll" i18n="Accept all changes radio@@AcceptAll">Prihvati sve</label>
                </div>
                <div class="custom-radio">
                  <input type="radio" id="acceptHigher" name="acceptOdd" [value]="oddsValidationModeEnum.AcceptHigherOdds"
                    [(ngModel)]="oddsValidationMode" [attr.checked]="oddsValidationMode === oddsValidationModeEnum.AcceptHigherOdds" (click)="changeOddsValidationMode(oddsValidationModeEnum.AcceptHigherOdds)">
                  <label for="acceptHigher" i18n="Accept higher changes radio@@AcceptHigher">Prihvati veću</label>
                </div>
              </div>
            </div>
            <div class="potential-winning">
              <span i18n="Possible paout ticket calculator@@PossiblePayout" *ngIf="viewConfigurations.ticketShowPotentalWinWitoutTax && numberOfBets > 1">Ev. isplata</span>
              <span i18n="Ticket Pay out text@@TicketPayOut" *ngIf="viewConfigurations.ticketShowPotentalWinWitoutTax && numberOfBets == 1">Isplata</span>
              <span i18n="Possible win ticket calculator@@PossibleWin" *ngIf="!viewConfigurations.ticketShowPotentalWinWitoutTax">POTENCIJALNI DOBITAK </span>
              <span class="bold" *ngIf="!viewConfigurations.ticketShowPotentalWinWitoutTax">{{possibleWin | number:'1.0-2'}} {{constantValues.CURRENCY}}</span>
              <span class="bold" *ngIf="viewConfigurations.ticketShowPotentalWinWitoutTax">{{possibleWinWithoutTax | number:'1.2-2'}} {{constantValues.CURRENCY}}</span>
              <!-- <span class="bold">{{possibleWin | odd}} {{constantValues.CURRENCY}}</span> -->
            </div>

            <div class="empty-ticket" *ngIf="!isTicketOnline && orderingForTicketItemGroups.length > 0"  (click)="removeOfflineTicketItems()">
              <i class="sporticon sporticon-delete"></i>
              <ng-container i18n="delete offline ticket items@@deleteOfflineTicketItems">BRIŠI TIKET</ng-container>
            </div>
            <div class="empty-ticket" (click)="removeAllTicketItems()">
              <i class="sporticon sporticon-delete"></i>
              <ng-container i18n="Delete ticket@@deleteTicket">BRIŠI TIKET</ng-container>
            </div>
          </section>
        </ng-container>

        <app-my-ticket *ngIf="selectedTab == TicketTabENUM.MyTickets && !isMobileView"></app-my-ticket>
        <app-my-tickets-mobile *ngIf="selectedTab == TicketTabENUM.MyTickets && isMobileView"></app-my-tickets-mobile>
        <app-find-ticket *ngIf="selectedTab == TicketTabENUM.FindTicket && isScanActive" (scanResult)="scanTicketCompleted($event)"></app-find-ticket>
      </section>

      <section class="ticket-check-wrap" *ngIf="(!isMobileView || (isMobileView && selectedTab == TicketTabENUM.FindTicket)) && isUserLoggedIn">
        <div *ngIf="isMobileView" class="scan-button-wrap">
          <button *ngIf="!isScanActive" class="button btn outline-primary small" i18n="Ticket startScanning button@@TicketstartScanningButton" (click)="startScanning()">SKENIRAJ</button>
          <button *ngIf="isScanActive" class="button btn outline-primary small" i18n="Ticket stopScaning button@@TicketstopScaningButton" (click)="stopScaning()" >ZAUSTAVI SKENIRANJE</button>
        </div>
        <div>
          <input class="code1 form-control form-control-sm" id="ticketId" type="text" [(ngModel)]="checkTicketId" placeholder="000 000 000 000 00" maxlength="20" (keypress)="setIsSearchValid($event.keyCode)" />
          <input class="code2 form-control form-control-sm" id="ticketPin" type="text" [(ngModel)]="checkTicketPin" placeholder="0000" maxlength="4" (keypress)="setIsSearchValid($event.keyCode)" />
          <button class="button btn outline-primary small" i18n="Ticket check button@@TicketCheckButton" (click)="checkTicket()">PROVERI</button>
        </div>
        <div class="check-message" *ngIf="!isSearchValid">{{searchMessage}}</div>
      </section>
    </div>
  </section>
</div>
